export const reactSelectStyle = {
  menuList: {
    maxHeight: '200px',
    overflowY: 'auto',
  },
  control: {
    boxSizing: 'border-box',
    fontSize: 'var(--font-body2)',
  },
};
